import { createI18n } from 'vue-i18n';
import ET from '../lang/et.yml';
import EN from '../lang/en.yml';
import RU from '../lang/ru.yml';

export const ALL_LANGS = [
  'et',
  'en',
  'ru',
];

export const i18n = createI18n({
  legacy: false,
  locale: ALL_LANGS[0],
  fallbackLocale: ALL_LANGS[1],
  warnHtmlMessage: false,
  messages: {
    et: ET,
    en: EN,
    ru: RU,
  },
  numberFormats: {
    et: ET.numberFormats,
    en: EN.numberFormats,
    ru: RU.numberFormats,
  },
  datetimeFormats: {
    et: ET.dateTimeFormats,
    en: EN.dateTimeFormats,
    ru: RU.dateTimeFormats,
  },
});
